var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { ModalConfig } from '../../../model/modal-config';
import { BaseActions } from '../../../shared/base-actions';
import { Order } from '../../../model/order';
import { PageNames } from '../../../shared/page-names.enum';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { NavigationState } from '../../../model/navigation/navigation-state';
import { EmitterConstants } from '../../../shared/emitter-constants';
import { Emitter } from '../../../shared/utils/emitter/emitter';
import { takeUntil } from 'rxjs/operators';
import { AnalyticsService } from '../../../services/analytics/analytics.service';
import { OmapiIdConstants } from '../../../shared/omapi-id-constants';
var TrialModalManagerComponent = /** @class */ (function (_super) {
    __extends(TrialModalManagerComponent, _super);
    function TrialModalManagerComponent(navigationService, analyticsService) {
        var _this = _super.call(this) || this;
        _this.navigationService = navigationService;
        _this.analyticsService = analyticsService;
        _this.modalConfig = new ModalConfig();
        _this.navigationState = new NavigationState();
        _this.previousPageState = new NavigationState();
        _this.trialsToCompare = [];
        _this.runningTrials = [];
        _this.eventSubscriptions = [];
        return _this;
    }
    TrialModalManagerComponent.prototype.ngOnInit = function () {
        this.subscribeToEvents();
    };
    TrialModalManagerComponent.prototype.subscribeToEvents = function () {
        var _this = this;
        this.eventSubscriptions.push(Emitter.of(EmitterConstants.BACK_PRESSED).pipe(takeUntil(this.stopSubscription)).subscribe(function (backValue) { return _this.handleOnBackValue(backValue); }));
        this.eventSubscriptions.push(Emitter.of(EmitterConstants.OPEN_CONDITIONAL_MODAL).pipe(takeUntil(this.stopSubscription)).subscribe(function (value) { return _this.openConditions(value); }));
        this.eventSubscriptions.push(Emitter.of(EmitterConstants.OPEN_INPUT_TRIAL_CODE_MODAL).pipe(takeUntil(this.stopSubscription)).subscribe(function (value) { return _this.openTrialActivationModal(value); }));
        this.eventSubscriptions.push(Emitter.of(EmitterConstants.OPEN_TRIAL_COMPARISON_MODAL).pipe(takeUntil(this.stopSubscription)).subscribe(function (trials) { return _this.openTrialComparison(trials); }));
        this.eventSubscriptions.push(Emitter.of(EmitterConstants.OPEN_TRIAL_SUCCESS_MODAL).pipe(takeUntil(this.stopSubscription)).subscribe(function (trial) { return _this.openTrialSuccessModal(trial); }));
        this.eventSubscriptions.push(Emitter.of(EmitterConstants.OPEN_TRIAL_MAX_ATTEMPTS_REACHED_MODAL).pipe(takeUntil(this.stopSubscription)).subscribe(function (x) { return _this.showTrialMaxAttemptsReached(); }));
        this.eventSubscriptions.push(Emitter.of(EmitterConstants.OPEN_TRIAL_ACTIVATION_TIMEOUT).pipe(takeUntil(this.stopSubscription)).subscribe(function (value) { return _this.openTrialActivationPendingModal(value); }));
    };
    TrialModalManagerComponent.prototype.openTrialSuccessModal = function (trial) {
        if (trial) {
            this.successOmapiId = trial.parentOmapiId;
            this.trialOmapiId = trial.omapiId;
            this.analyticsService.onVoucherCodeSuccess(this.trialOmapiId);
            this.showTrialSuccessModal();
        }
    };
    TrialModalManagerComponent.prototype.openTrialComparison = function (trials) {
        if (trials && trials.length > 0) {
            this.trialsToCompare = trials;
            this.showTrialComparisonModal();
        }
    };
    TrialModalManagerComponent.prototype.openTrialActivationModal = function (value) {
        if (value) {
            this.previousPage = this.entryComponent = value;
            this.showTrialActivationModal();
        }
    };
    TrialModalManagerComponent.prototype.handleOnBackValue = function (backValue) {
        this.previousPage = backValue;
        if (backValue === PageNames.TRIAL_COMPARISON_MODAL) {
            this.showTrialActivationModal(backValue);
        }
        else if (backValue.componentName === PageNames.TRIAL_SUCCESS_MODAL) {
            if (this.entryComponent === PageNames.PLAY_SPORTS_PAGE
                && backValue.omapiId === OmapiIdConstants.PLAY_SPORTS_TRIAL) {
                this.removeDayPassAndTrialButtonsFromOrderOptions();
            }
            this.resetModalConfig(this.entryComponent, this.previousPageState);
        }
        else if (backValue !== this.entryComponent && this.entryComponent === PageNames.FIND_TRIAL_CODE_MODAL) {
            this.showFindTrialModal();
        }
        else if (backValue === PageNames.TRIAL_ATTEMPTS_REACHED) {
            this.showTrialActivationModal();
        }
        else if (this.entryComponent === PageNames.PLAY_SPORTS_PAGE) {
            this.resetModalConfig(PageNames.PLAY_SPORTS_PAGE, this.previousPageState);
        }
        else {
            this.resetModalConfig(PageNames.TRIALS_PAGE, this.previousPageState);
        }
    };
    TrialModalManagerComponent.prototype.removeDayPassAndTrialButtonsFromOrderOptions = function () {
        var ORDER_OPTIONS_SECTION = 'productDetailOrderOptions';
        var lastNavItemIndex = this.previousPageState.navItemSource[ORDER_OPTIONS_SECTION][0].length - 1;
        this.previousPageState.navItemSource[ORDER_OPTIONS_SECTION][0] = this.previousPageState.navItemSource[ORDER_OPTIONS_SECTION][0].slice(0, lastNavItemIndex - 1);
        this.previousPageState.activeX = 0;
        this.previousPageState.navItemSource[ORDER_OPTIONS_SECTION][0][0].active = true;
    };
    TrialModalManagerComponent.prototype.openConditions = function (value) {
        if (value) {
            this.modalConfig.showTrialCode = false;
            this.modalConfig.showOrderConditions = true;
            this.registerComponent(PageNames.CONDITIONS_MODAL);
        }
    };
    TrialModalManagerComponent.prototype.openTrialActivationPendingModal = function (value) {
        if (value) {
            if (value.component === PageNames.TRIAL_COMPARISON_MODAL) {
                this.modalConfig.showTrialComparison = false;
            }
            else if (value.component === PageNames.TRIAL_CODE_MODAL) {
                this.modalConfig.showTrialCode = false;
            }
            this.trialOmapiId = value.trial.omapiId;
            this.modalConfig = new ModalConfig();
            this.navigationState = Object.assign({}, this.navigationService.state);
            this.previousPage = this.entryComponent;
            this.modalConfig.showTrialPending = true;
            this.error = value.error;
            this.registerComponent(PageNames.TRIAL_ACTIVATION_PENDING);
        }
    };
    TrialModalManagerComponent.prototype.closeConditions = function () {
        this.resetModalConfig(PageNames.TRIAL_CODE_MODAL, this.navigationState);
        this.showTrialActivationModal();
    };
    TrialModalManagerComponent.prototype.showTrialActivationModal = function (backValue) {
        this.modalConfig = new ModalConfig();
        this.modalConfig.showTrialCode = true;
        if (!backValue) {
            this.navigationState = Object.assign({}, this.navigationService.state);
        }
        if (this.previousPage === PageNames.TRIALS_PAGE || this.previousPage === PageNames.PLAY_SPORTS_PAGE) {
            this.previousPageState = this.navigationState;
        }
        this.registerComponent(PageNames.TRIAL_CODE_MODAL);
    };
    TrialModalManagerComponent.prototype.showTrialComparisonModal = function () {
        this.modalConfig = new ModalConfig();
        this.modalConfig.showTrialComparison = true;
        this.navigationState = Object.assign({}, this.navigationService.state);
        this.registerComponent(PageNames.TRIAL_COMPARISON_MODAL);
    };
    TrialModalManagerComponent.prototype.showFindTrialModal = function (savePageState) {
        this.modalConfig = new ModalConfig();
        this.modalConfig.showFindTrialCode = true;
        this.navigationState = Object.assign({}, this.navigationService.state);
        if (savePageState) {
            this.previousPageState = this.navigationState;
        }
        this.registerComponent(PageNames.FIND_TRIAL_CODE_MODAL);
    };
    TrialModalManagerComponent.prototype.showTrialSuccessModal = function () {
        this.modalConfig = new ModalConfig();
        this.modalConfig.showTrialSuccess = true;
        this.navigationState = Object.assign({}, this.navigationService.state);
        this.registerComponent(PageNames.TRIAL_SUCCESS_MODAL);
    };
    TrialModalManagerComponent.prototype.showTrialMaxAttemptsReached = function () {
        this.modalConfig = new ModalConfig();
        this.modalConfig.showTrialAttemptsReached = true;
        this.navigationState = Object.assign({}, this.navigationService.state);
        this.registerComponent(PageNames.TRIAL_ATTEMPTS_REACHED);
    };
    TrialModalManagerComponent.prototype.registerComponent = function (pageName) {
        this.navigationService.clearNavigation();
        this.navigationService.setCurrentPageComponent(pageName);
    };
    TrialModalManagerComponent.prototype.resetModalConfig = function (pageName, state) {
        this.modalConfig = new ModalConfig();
        this.registerComponent(pageName);
        this.navigationService.state = state;
        this.ngOnDestroy();
    };
    TrialModalManagerComponent.prototype.closeEventSubscriptions = function () {
        this.eventSubscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    TrialModalManagerComponent.prototype.closeModal = function () {
        this.modalConfig = new ModalConfig();
        this.registerComponent(PageNames.TRIAL_CODE_MODAL);
        if (!this.modalConfig.showOrderConditions && !this.modalConfig.showOrderPincode) {
            this.navigationService.state = this.navigationState;
        }
        this.ngOnDestroy();
    };
    TrialModalManagerComponent.prototype.onBack = function () {
        this.closeModal();
    };
    return TrialModalManagerComponent;
}(BaseActions));
export { TrialModalManagerComponent };
